export enum ToastIcons {
  Success = 'checkbox-circle-fill',
  Error = 'error-warning-fill',
  Close = 'close-fill',
}

export enum ToastPosition {
  BottomRight = 'bottom-right',
  TopRight = 'top-right',
  BottomLeft = 'bottom-left',
  TopLeft = 'top-left',
}

export enum ToastType {
  Success = 'success',
  Error = 'error',
}
